import React from 'react';
import { Link } from 'react-router-dom';
import { FaLinkedin } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* Brand Section */}
          <div className="footer-section">
            <h3 className="footer-brand-name">FLOWSKYCRM</h3>
            <p className="footer-description">
              İşinizi büyütmek için kapsamlı CRM çözümü. Müşteri ilişkilerinizi yönetin, 
              satışlarınızı artırın, ekibinizi organize edin.
            </p>
            <div className="social-links">
              <a href="https://www.linkedin.com/company/arma-bilisim-hizmetleri/posts/?feedView=all" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="social-link">
                <FaLinkedin />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h3 className="footer-title">Hızlı Linkler</h3>
            <ul className="footer-links">
              <li><Link to="/" onClick={scrollToTop}>Ana Sayfa</Link></li>
                  <li><Link to="/hakkimizda">Hakkımızda</Link></li>
              <li><Link to="/iletisim">İletişim</Link></li>
            </ul>
          </div>

          {/* Modules */}
          <div className="footer-section">
            <h3 className="footer-title">Modüller</h3>
            <ul className="footer-links">
              <li><Link to="/moduller#musteri-yonetimi">Müşteri Yönetimi</Link></li>
              <li><Link to="/moduller#satis-yonetimi">Satış Yönetimi</Link></li>
              <li><Link to="/moduller#gorev-takibi">Görev Takibi</Link></li>
              <li><Link to="/moduller#raporlama">Raporlama</Link></li>
              <li><Link to="/moduller#ekip-yonetimi">Ekip Yönetimi</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h3 className="footer-title">İletişim</h3>
            <ul className="footer-contact">
              <li>
                <span>Halkapınar, 1004. Sk. No:5 D:407, 35170<br />Konak/İzmir</span>
              </li>
              <li>
                <a href="mailto:info@flowskycrm.com">info@flowskycrm.com</a>
              </li>
              <li>
                <a href="tel:+905527134331">+90 552 713 43 31</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} FlowSky CRM. Tüm hakları saklıdır.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

